export enum CensusFileRowStatusEnum {
  IN_PROCESS = 'IN_PROCESS', // New row, hasn't been submitted
  IN_REVIEW = 'IN_REVIEW', // Sureco Admin is reviewing
  WITHDRAWN = 'WITHDRAWN', // No action taken on row, no action needed
  REJECTED = 'REJECTED', // No action taken on row, no action needed
  DELETED = 'DELETED', // ?? same as withdrawn?
  COMPLETE = 'COMPLETE', // Action has been taken on row ( create, terminate, update )
}
